module.exports = __webpack_public_path__ + "static/media/icon-integracao-connect.75c01032.png";